module.exports = __webpack_public_path__ + "img/arh_11.4f4a1e25.png";